export const ZarazEvents = {
  INSTALLATION_BUTTON_CLICK: "installation_button_click",
  CONSOLE_LINK_CLICK: "console_link_click",
} as const;

export type ZarazEvent = typeof ZarazEvents[keyof typeof ZarazEvents];
